import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthorizeService } from '../authorize.service';

@Injectable({
  providedIn: 'root',
})
export class DevelopmentGuard {
  private readonly authorize = inject(AuthorizeService);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authorize.getUser().pipe(map((user) => user?.agencyNumber === '3213210'));
  }
}
